import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ErrorStatusCodes } from '@edtech-ui/constants/error-status-code.enum';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {

	const _toastr = inject(ToastrService);
	return next(req).pipe(
		catchError((error: HttpErrorResponse) => {
			const refreshToken = localStorage.getItem('refresh_token');

			if (error.status === 401 && refreshToken) {
				return throwError(() => error);
			}

			let message = 'Something went wrong. Please try again.';
			if (error.error?.message) {
				message = error.error.message;
			} else if (error.error?.Message) {
				message = error.error.Message;
			} else if (error.status === ErrorStatusCodes.NetworkError) {
				message = 'Network error.Please check your connection.';
			} else if (error.status === ErrorStatusCodes.Unauthorized) {
				message = 'Unauthorized.Please login again.';
			} else if (error.status === ErrorStatusCodes.NotFound) {
				message = 'Requested resource not found.';
			} else if (error.status === ErrorStatusCodes.InternalServerError) {
				message = 'Server error. Please try again later.';
			} else if (error.status === ErrorStatusCodes.PayloadTooLarge) {
				message = 'File too large. Please upload a file smaller than 10 MB.'
			}
			_toastr.error(message);
			return throwError(() => error);
		})
	);
};